import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { CommunityPolicyComponent } from '../community-policy.component';

@Component({
    imports: [AngularSvgIconModule, CommunityPolicyComponent],
    selector: 'rdx-community-policy-dialog',
    standalone: true,
    styleUrls: ['./community-policy-dialog.component.scss'],
    templateUrl: './community-policy-dialog.component.html',
})
export class CommunityPolicyDialogComponent {
    communityPolicyText: string;

    constructor(
        private matDialogRef: MatDialogRef<CommunityPolicyDialogComponent>
    ) {}

    onCancel(): void {
        this.matDialogRef.close();
    }
}
